module.exports = __webpack_public_path__ + "img/epagri-logo.8a6745b3.png";